import RegistrationEmailPinVerify from './RegistrationEmailPinVerify';

export default RegistrationEmailPinVerify;
